import { render, staticRenderFns } from "./main-contacts.vue?vue&type=template&id=36c33bc2"
import script from "./main-contacts.vue?vue&type=script&lang=js"
export * from "./main-contacts.vue?vue&type=script&lang=js"
import style0 from "./main-contacts.vue?vue&type=style&index=0&id=36c33bc2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports